import { Injectable, Signal, computed } from "@angular/core";
import { Account } from ".";
import { AccountDataSource } from "./account.datasource";
import { toSignal } from "@angular/core/rxjs-interop";
import { Subscription } from "./subscription.model";
import { map } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AccountRepository {
    account: Signal<Account>;
    subscription: Signal<Subscription>;

    constructor(
        private dataSource: AccountDataSource
    ) {
        this.account = toSignal(this.dataSource.account$.pipe(
            map(account => account ?? ({} as Account))
        ), {
            initialValue: {} as Account
        });

        this.subscription = toSignal(this.dataSource.getSubscription(), {
            initialValue: {} as Subscription
        });
    }

    get fullName(): Signal<string> {
        return computed(() => {
            if (this.account()) {
                if (this.account().firstName && this.account().lastName) {
                    return `${this.account().firstName} ${this.account().lastName}`;
                } else if (this.account().name) {
                    return this.account().name;
                } else {
                    return this.account().email ?? '';
                }
            } else {
                return '';
            }
        })
    }

    get initials(): Signal<string> {
        return computed(() => {
            if (this.fullName() && this.fullName().length > 0) {
                const words = this.fullName().split(' ');

                if (words.length === 1) {
                    return words[0][0].toUpperCase();
                } else {
                    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
                }
            } else {
                return '';
            }
        })
    }

    refreshSubscription() {
        this.dataSource.refreshSubscription();
    }

    updateMarketingPreferences(suppressed: boolean) {
        return this.dataSource.updateMarketingPreferences(suppressed);
    }
}
